<template>
  <section v-if="titles">
    <h1
      class="w-100 display-3 mb-5 text-white text-center text-lg-left"
      :style="titles.mainTitleSize ? { fontSize: titles.mainTitleSize } : {}"
    >
      {{ titles.mainTitle }}
    </h1>

    <p class="w-100 text-white font-weight-normal mb-5" style="font-size: 1.2rem">
      {{ titles.description }}
    </p>
  </section>
</template>

<script>
export default {
  name: 'SupportText',
  props: {
    titles: {
      type: Object,
      required: true,
    },
  },
}
</script>
